import { render, staticRenderFns } from "./PromoCodeModule.vue?vue&type=template&id=4b544c71"
import script from "./PromoCodeModule.vue?vue&type=script&lang=js"
export * from "./PromoCodeModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports